// src/hooks/useWithdrawalEligibility.ts
import { useQuery } from '@tanstack/react-query';
import { withdrawalService } from '../services/withdrawalService';

export const useWithdrawalEligibility = () => {
  return useQuery({
    queryKey: ['withdrawal-eligibility'],
    queryFn: () => withdrawalService.checkEligibility(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (cacheTime dans v4)
    retry: 1,
    retryDelay: 1000,
    enabled: true, // Toujours activé
  });
};